<template>
  <div class="report-list-container">
    <!-- 查询表单 -->
    <el-card class="search-card">
      <template #header>
        <div class="card-header">
          <span>查询条件</span>
          <el-button type="text" @click="toggleSearchForm">
            {{ showSearchForm ? '收起' : '展开' }}
          </el-button>
        </div>
      </template>
      
      <el-collapse-transition>
        <div v-show="showSearchForm" class="search-form">
          <el-form :model="searchForm" :inline="!isMobile" class="responsive-form">
            <el-form-item label="样品名称">
              <el-input 
                v-model="searchForm.sampleName" 
                placeholder="请输入样品名称"
                clearable
                @clear="handleSearch"
                @keyup.enter="handleSearch"
              ></el-input>
            </el-form-item>
            <el-form-item label="报告编号">
              <el-input 
                v-model="searchForm.sampleNumber" 
                placeholder="请输入报告编号"
                clearable
                @clear="handleSearch"
                @keyup.enter="handleSearch"
              ></el-input>
            </el-form-item>
         
            <!-- <el-form-item label="样品状态">
              <el-input 
                v-model="searchForm.sampleStatus" 
                placeholder="请输入样品状态"
                clearable
                @clear="handleSearch"
                @keyup.enter="handleSearch"
              ></el-input>
            </el-form-item> -->
            <el-form-item label="委托单位">
              <el-input 
                v-model="searchForm.clientUnit" 
                placeholder="请输入委托单位"
                clearable
                @clear="handleSearch"
                @keyup.enter="handleSearch"
              ></el-input>
            </el-form-item>
            <el-form-item label="来源公司">
              <el-input 
                v-model="searchForm.partnerCompany" 
                placeholder="请输入来源公司"
                clearable
                @clear="handleSearch"
                @keyup.enter="handleSearch"
              ></el-input>
            </el-form-item>
            <el-form-item label="上传时间">
              <el-date-picker
                v-model="searchForm.uploadDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                @change="handleSearch"
                :size="isMobile ? 'small' : 'default'"
              ></el-date-picker>
            </el-form-item>
            <el-form-item class="form-actions">
              <el-button type="primary" @click="searchReports" :size="isMobile ? 'small' : 'default'">查询</el-button>
              <el-button @click="resetSearch" :size="isMobile ? 'small' : 'default'">重置</el-button>
              <el-button type="info" @click="refreshReports" :loading="loading" :size="isMobile ? 'small' : 'default'">刷新</el-button>
              <el-button v-if="isDesktop" type="success" @click="exportData" :size="isMobile ? 'small' : 'default'">导出数据</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </el-card>

    <el-card>
      <template #header>
        <div class="card-header">
          <span>报告管理</span>
          <div class="header-actions">
            <el-button type="primary" @click="showUploadDialog = true" :size="isMobile ? 'small' : 'default'">上传报告</el-button>
            <el-switch
              v-model="showDownloadButton"
              active-text="显示下载按钮"
              inactive-text="隐藏下载按钮"
              @change="handleDownloadButtonVisibilityChange"
              style="margin-left: 15px;"
            ></el-switch>
            <!-- <el-button v-if="isMobile" type="success" @click="exportData" :size="isMobile ? 'small' : 'default'">导出</el-button> -->
          </div>
        </div>
      </template>
      
      <!-- 桌面端表格 -->
      <el-table v-if="isDesktop" :data="displayReports" style="width: 100%" v-loading="loading" stripe>
        <el-table-column prop="sampleName" label="样品名称" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sampleNumber" label="报告编号" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="inspectionStatus" label="检验状态" width="100">
          <template #default="scope">
            <el-tag :type="getStatusType(scope.row.inspectionStatus)">
              {{ scope.row.inspectionStatus || '待检验' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="inspectionType" label="检验类型" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sampleStatus" label="样品状态" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="clientUnit" label="委托单位" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="inspectedUnit" label="受检单位" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="manufacturerUnit" label="生产单位" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="completionDeadline" label="完成期限" width="120">
          <template #default="scope">
            {{ formatDeadline(scope.row.completionDeadline) }}
          </template>
        </el-table-column>
        <el-table-column prop="partnerCompany" label="来源公司" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="uploadTime" label="上传时间" width="180">
          <template #default="scope">
            {{ formatUploadTime(scope.row.uploadTime) }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="产品报告" width="120">
          <template #default="scope">
            <el-button type="text" @click="viewReport(scope.row.id)" size="small">
              {{ scope.row.fileName }}
            </el-button>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="400" fixed="right">
          <template #default="scope">
            <el-button type="primary" size="small" @click="editReport(scope.row)">编辑</el-button>
            <el-button type="success" size="small" @click="uploadAttachment(scope.row)">报告上传</el-button>
            <el-button type="warning" size="small" @click="generateQRCode(scope.row)">生成二维码</el-button>
            <el-button type="danger" size="small" @click="deleteReport(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- PC端分页 -->
      <div v-if="isDesktop && total > 0" class="pagination-container">
        <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handlePageSizeChange"
          @current-change="handlePageChange"
        />
      </div>
      
      <!-- 移动端卡片布局 -->
      <div v-if="isMobile" class="mobile-card-list" v-loading="loading">
        <div v-for="report in displayReports" :key="report.id" class="report-card">
          <div class="card-header-mobile">
            <div class="report-title">
              <h3>{{ report.sampleName }}</h3>
              <span class="sample-number">{{ report.sampleNumber }}</span>
            </div>
            <el-tag :type="getStatusType(report.inspectionStatus)" size="small">
              {{ report.inspectionStatus || '待检验' }}
            </el-tag>
          </div>
          
          <div class="card-content">
            <div class="info-row" v-if="report.inspectionType">
              <span class="label">检验类型:</span>
              <span class="value">{{ report.inspectionType }}</span>
            </div>
            <div class="info-row" v-if="report.sampleStatus">
              <span class="label">样品状态:</span>
              <span class="value">{{ report.sampleStatus }}</span>
            </div>
            <div class="info-row" v-if="report.clientUnit">
              <span class="label">委托单位:</span>
              <span class="value">{{ report.clientUnit }}</span>
            </div>
            <div class="info-row" v-if="report.partnerCompany">
              <span class="label">来源公司:</span>
              <span class="value">{{ report.partnerCompany }}</span>
            </div>
            <div class="info-row" v-if="report.completionDeadline">
              <span class="label">完成期限:</span>
              <span class="value">{{ formatDeadline(report.completionDeadline) }}</span>
            </div>
            <div class="info-row">
              <span class="label">上传时间:</span>
              <span class="value">{{ formatUploadTime(report.uploadTime) }}</span>
            </div>
          </div>
          
          <div class="card-actions">
            <el-button type="primary" size="small" @click="editReport(report)">编辑</el-button>
            <el-button type="success" size="small" @click="uploadAttachment(report)">上传</el-button>
            <el-button type="warning" size="small" @click="generateQRCode(report)">二维码</el-button>
            <el-button type="danger" size="small" @click="deleteReport(report)">删除</el-button>
          </div>
        </div>
      </div>
      
      <!-- 手机端加载更多按钮 -->
      <div v-if="isMobile && hasMore && displayReports.length > 0" class="load-more-container">
        <el-button @click="loadMore" :loading="loading" type="primary" plain>
          加载更多
        </el-button>
      </div>
      
      <div v-if="displayReports.length === 0 && !loading" class="empty-state">
        <el-empty description="暂无报告数据">
          <el-button type="primary" @click="showUploadDialog = true">上传第一个报告</el-button>
        </el-empty>
      </div>
    </el-card>

    <!-- 新建报告对话框 -->
    <el-dialog v-model="showUploadDialog" title="新建报告" width="720px" :close-on-click-modal="false">
      <el-form :model="uploadForm" :rules="uploadRules" ref="uploadFormRef" label-width="120px">
        <el-form-item label="样品名称" prop="sampleName" required>
          <el-input v-model="uploadForm.sampleName" placeholder="请输入样品名称"></el-input>
        </el-form-item>
        <el-form-item label="报告编号">
          <div class="report-code-builder">
            <span class="report-code-prefix">{{ getCompanyCode(uploadForm.partnerCompany) || '--' }}</span>
            <el-input
              v-if="requiresCustom4(uploadForm.partnerCompany)"
              v-model="uploadForm.reportCodeCustom4"
              maxlength="4"
              placeholder="四位数字"
              class="report-code-custom-input"
              @input="handleUploadCustom4Input"
            />
            <span v-else class="report-code-auto-tip">自动生成10位数字</span>
            <el-button type="primary" class="report-code-action" @click="generateUploadReportNumber">随机生成</el-button>
            <el-button class="report-code-clear" @click="clearUploadReportNumber">清空</el-button>
          </div>
          <el-input v-model="uploadForm.sampleNumber" class="report-code-result" readonly placeholder="点击随机生成报告编号"></el-input>
          <div class="code-preview-tip">{{ getReportCodeRuleText(uploadForm.partnerCompany) }}</div>
        </el-form-item>
        <el-form-item label="检验状态" prop="inspectionStatus">
          <el-select v-model="uploadForm.inspectionStatus" placeholder="请选择检验状态">
            <el-option label="待检验" value="待检验"></el-option>
            <el-option label="检验中" value="检验中"></el-option>
            <el-option label="已完成" value="已完成"></el-option>
            <el-option label="已取消" value="已取消"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检验类型" prop="inspectionType">
          <el-input v-model="uploadForm.inspectionType" placeholder="请输入检验类型"></el-input>
        </el-form-item>
        <el-form-item label="样品状态" prop="sampleStatus">
          <el-input v-model="uploadForm.sampleStatus" placeholder="请输入样品状态"></el-input>
        </el-form-item>
        <el-form-item label="委托单位" prop="clientUnit">
          <el-input v-model="uploadForm.clientUnit" placeholder="请输入委托单位"></el-input>
        </el-form-item>
        <el-form-item label="受检单位" prop="inspectedUnit">
          <el-input v-model="uploadForm.inspectedUnit" placeholder="请输入受检单位"></el-input>
        </el-form-item>
        <el-form-item label="生产单位" prop="manufacturerUnit">
          <el-input v-model="uploadForm.manufacturerUnit" placeholder="请输入生产单位"></el-input>
        </el-form-item>
        <el-form-item label="完成期限" prop="completionDeadline">
          <el-date-picker
            v-model="uploadForm.completionDeadline"
            type="date"
            placeholder="请选择完成期限"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="来源公司" prop="partnerCompany">
          <el-select v-model="uploadForm.partnerCompany" placeholder="请选择来源公司" @change="handleUploadCompanyChange">
            <el-option label="必维" value="必维"></el-option>
            <el-option label="中鼎" value="中鼎"></el-option>
            <el-option label="中检通" value="中检通"></el-option>
            <el-option label="宝通" value="宝通"></el-option>
            <el-option label="德凯" value="德凯"></el-option>
            <el-option label="柏纶" value="柏纶"></el-option>
          </el-select>
        </el-form-item>

        <!-- 德凯专用字段 -->
        <template v-if="uploadForm.partnerCompany === '德凯'">
          <el-divider content-position="left">德凯报告信息</el-divider>
          <el-form-item label="公司名称" prop="dekaiCompanyName">
            <el-input v-model="uploadForm.dekaiCompanyName" placeholder="请输入公司名称"></el-input>
          </el-form-item>
          <el-form-item label="产品名称" prop="dekaiProductName">
            <el-input v-model="uploadForm.dekaiProductName" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="产品型号" prop="dekaiProductModel">
            <el-input v-model="uploadForm.dekaiProductModel" placeholder="请输入产品型号"></el-input>
          </el-form-item>
          <el-form-item label="签发日期" prop="dekaiIssueDate">
            <el-date-picker
              v-model="uploadForm.dekaiIssueDate"
              type="date"
              placeholder="请选择签发日期"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
            ></el-date-picker>
          </el-form-item>
        </template>

        <!-- 宝通、中检通共用字段 -->
        <template v-if="['宝通', '中检通'].includes(uploadForm.partnerCompany)">
          <el-divider content-position="left">{{ uploadForm.partnerCompany }}报告信息</el-divider>
          <el-form-item label="申请人" prop="baotongApplicant">
            <el-input v-model="uploadForm.baotongApplicant" placeholder="请输入申请人"></el-input>
          </el-form-item>
          <el-form-item label="申请人地址" prop="baotongApplicantAddress">
            <el-input v-model="uploadForm.baotongApplicantAddress" placeholder="请输入申请人地址" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="生产企业" prop="baotongManufacturer">
            <el-input v-model="uploadForm.baotongManufacturer" placeholder="请输入生产企业"></el-input>
          </el-form-item>
          <el-form-item label="生产企业地址" prop="baotongManufacturerAddress">
            <el-input v-model="uploadForm.baotongManufacturerAddress" placeholder="请输入生产企业地址" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="产品名称" prop="baotongProductName">
            <el-input v-model="uploadForm.baotongProductName" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="主测型号" prop="baotongMainModel">
            <el-input v-model="uploadForm.baotongMainModel" placeholder="请输入主测型号"></el-input>
          </el-form-item>
          <el-form-item label="附加型号" prop="baotongAdditionalModel">
            <el-input v-model="uploadForm.baotongAdditionalModel" placeholder="请输入附加型号"></el-input>
          </el-form-item>
        </template>
      </el-form>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="cancelUpload">取消</el-button>
          <el-button type="primary" @click="submitUpload" :loading="uploading">保存</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 编辑报告对话框 -->
    <el-dialog v-model="showEditDialog" title="编辑报告" width="720px" :close-on-click-modal="false">
      <el-form :model="editForm" :rules="editRules" ref="editFormRef" label-width="120px">
        <el-form-item label="样品名称" prop="sampleName" required>
          <el-input v-model="editForm.sampleName" placeholder="请输入样品名称"></el-input>
        </el-form-item>
        <el-form-item label="报告编号">
          <el-input v-model="editForm.sampleNumber" class="report-code-result edit-report-code-result" readonly></el-input>
        </el-form-item>
        <el-form-item label="检验状态" prop="inspectionStatus">
          <el-select v-model="editForm.inspectionStatus" placeholder="请选择检验状态">
            <el-option label="待检验" value="待检验"></el-option>
            <el-option label="检验中" value="检验中"></el-option>
            <el-option label="已完成" value="已完成"></el-option>
            <el-option label="已取消" value="已取消"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检验类型" prop="inspectionType">
          <el-input v-model="editForm.inspectionType" placeholder="请输入检验类型"></el-input>
        </el-form-item>
        <el-form-item label="样品状态" prop="sampleStatus">
          <el-input v-model="editForm.sampleStatus" placeholder="请输入样品状态"></el-input>
        </el-form-item>
        <el-form-item label="委托单位" prop="clientUnit">
          <el-input v-model="editForm.clientUnit" placeholder="请输入委托单位"></el-input>
        </el-form-item>
        <el-form-item label="受检单位" prop="inspectedUnit">
          <el-input v-model="editForm.inspectedUnit" placeholder="请输入受检单位"></el-input>
        </el-form-item>
        <el-form-item label="生产单位" prop="manufacturerUnit">
          <el-input v-model="editForm.manufacturerUnit" placeholder="请输入生产单位"></el-input>
        </el-form-item>
        <el-form-item label="完成期限" prop="completionDeadline">
          <el-date-picker
            v-model="editForm.completionDeadline"
            type="date"
            placeholder="请选择完成期限"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="来源公司" prop="partnerCompany">
          <el-select v-model="editForm.partnerCompany" placeholder="请选择来源公司" @change="handleEditCompanyChange">
            <el-option label="必维" value="必维"></el-option>
            <el-option label="中鼎" value="中鼎"></el-option>
            <el-option label="中检通" value="中检通"></el-option>
            <el-option label="宝通" value="宝通"></el-option>
            <el-option label="德凯" value="德凯"></el-option>
            <el-option label="柏纶" value="柏纶"></el-option>
          </el-select>
        </el-form-item>

        <!-- 德凯专用字段 -->
        <template v-if="editForm.partnerCompany === '德凯'">
          <el-divider content-position="left">德凯报告信息</el-divider>
          <el-form-item label="公司名称" prop="dekaiCompanyName">
            <el-input v-model="editForm.dekaiCompanyName" placeholder="请输入公司名称"></el-input>
          </el-form-item>
          <el-form-item label="产品名称" prop="dekaiProductName">
            <el-input v-model="editForm.dekaiProductName" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="产品型号" prop="dekaiProductModel">
            <el-input v-model="editForm.dekaiProductModel" placeholder="请输入产品型号"></el-input>
          </el-form-item>
          <el-form-item label="签发日期" prop="dekaiIssueDate">
            <el-date-picker
              v-model="editForm.dekaiIssueDate"
              type="date"
              placeholder="请选择签发日期"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
            ></el-date-picker>
          </el-form-item>
        </template>

        <!-- 宝通、中检通共用字段 -->
        <template v-if="['宝通', '中检通'].includes(editForm.partnerCompany)">
          <el-divider content-position="left">{{ editForm.partnerCompany }}报告信息</el-divider>
          <el-form-item label="申请人" prop="baotongApplicant">
            <el-input v-model="editForm.baotongApplicant" placeholder="请输入申请人"></el-input>
          </el-form-item>
          <el-form-item label="申请人地址" prop="baotongApplicantAddress">
            <el-input v-model="editForm.baotongApplicantAddress" placeholder="请输入申请人地址" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="生产企业" prop="baotongManufacturer">
            <el-input v-model="editForm.baotongManufacturer" placeholder="请输入生产企业"></el-input>
          </el-form-item>
          <el-form-item label="生产企业地址" prop="baotongManufacturerAddress">
            <el-input v-model="editForm.baotongManufacturerAddress" placeholder="请输入生产企业地址" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="产品名称" prop="baotongProductName">
            <el-input v-model="editForm.baotongProductName" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="主测型号" prop="baotongMainModel">
            <el-input v-model="editForm.baotongMainModel" placeholder="请输入主测型号"></el-input>
          </el-form-item>
          <el-form-item label="附加型号" prop="baotongAdditionalModel">
            <el-input v-model="editForm.baotongAdditionalModel" placeholder="请输入附加型号"></el-input>
          </el-form-item>
        </template>
      </el-form>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="cancelEdit">取消</el-button>
          <el-button type="primary" @click="submitEdit" :loading="editing">保存</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 报告上传对话框 -->
    <el-dialog v-model="showAttachmentDialog" title="报告上传" width="500px" :close-on-click-modal="false">
      <el-form :model="attachmentForm" ref="attachmentFormRef" label-width="120px">
        <el-form-item label="报告文件" prop="attachmentFile" required>
          <el-upload
            ref="attachmentUploadRef"
            :auto-upload="false"
            :limit="1"
            :on-change="handleAttachmentChange"
            :on-remove="handleAttachmentRemove"
            accept=".pdf,.doc,.docx,.txt"
            :show-file-list="true"
          >
            <el-button type="primary">选择报告文件</el-button>
            <template #tip>
              <div class="el-upload__tip">
                支持 PDF、Word、TXT 格式，文件大小不超过 50MB
              </div>
            </template>
          </el-upload>
        </el-form-item>
        
        <!-- 上传进度条 -->
        <el-form-item v-if="uploadingAttachment" label="上传进度">
          <el-progress 
            :percentage="uploadProgress" 
            :status="uploadProgress === 100 ? 'success' : ''"
            :stroke-width="8"
          />
          <div class="upload-status" v-if="uploadProgress < 100">
            正在上传文件...
          </div>
          <div class="upload-status" v-else>
            文件上传完成，正在处理...
          </div>
        </el-form-item>
      </el-form>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="cancelAttachment" :disabled="uploadingAttachment">取消</el-button>
          <el-button 
            type="primary" 
            @click="submitAttachment" 
            :loading="uploadingAttachment"
            :disabled="!attachmentForm.attachmentFile"
          >
            上传
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 生成二维码对话框 -->
    <el-dialog v-model="showQRCodeDialog" title="生成二维码" width="400px" :close-on-click-modal="false">
      <div class="qr-code-container">
        <div class="qr-code-display">
          <canvas ref="qrCodeCanvas" width="200" height="200" :style="{ display: qrCodeData ? 'block' : 'none' }"></canvas>
          <div v-if="!qrCodeData" class="qr-code-loading">
            <el-icon class="is-loading"><Loading /></el-icon>
            <p>正在生成二维码...</p>
          </div>
          <p v-if="qrCodeData" class="qr-code-info">扫描二维码查看报告详情</p>
        </div>
      </div>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showQRCodeDialog = false">关闭</el-button>
          <el-button type="primary" @click="saveQRCode" :disabled="!qrCodeData">保存二维码</el-button>
        </span>
      </template>
    </el-dialog>

    

    <!-- 删除确认对话框 -->
    <el-dialog v-model="showDeleteDialog" title="确认删除" width="400px">
      <p>确定要删除报告 "{{ deleteTarget?.sampleName }}" 吗？</p>
      <p style="color: #f56c6c; font-size: 14px;">此操作不可恢复，请谨慎操作！</p>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showDeleteDialog = false">取消</el-button>
          <el-button type="danger" @click="confirmDeleteReport" :loading="deleting">确认删除</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted, nextTick } from 'vue'
import { ElMessage } from 'element-plus'
import { Loading } from '@element-plus/icons-vue'
import { shouldShowMobileLayout, shouldShowDesktopLayout, getDeviceType } from '@/utils/deviceDetect'

export default {
  name: 'ReportList',
  setup() {
    const reports = ref([])
    const filteredReports = ref([])
    const loading = ref(false)
    const showSearchForm = ref(true)

    // 分页相关数据
    const currentPage = ref(1)
    const pageSize = ref(10)
    const total = ref(0)
    const displayReports = ref([]) // 当前显示的报告数据（PC端分页或手机端累积）

    // 设备类型检测
    const isMobile = ref(shouldShowMobileLayout())
    const isDesktop = ref(shouldShowDesktopLayout())
    const deviceType = ref(getDeviceType())
    const showDownloadButton = ref(true) // 控制下载按钮显示的状态，默认为 true
    
    
    // 在组件挂载时检测设备类型
    // 加载下载按钮显示设置
    const loadDownloadButtonSetting = async () => {
      try {
        console.log('正在加载下载按钮设置...')
        const response = await fetch('/api/settings/download-button', {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Cache-Control': 'no-cache'
          }
        })
        
        if (response.ok) {
          const data = await response.json()
          console.log('获取到的下载按钮设置:', data)
          showDownloadButton.value = data.visible
          console.log('设置下载按钮状态为:', showDownloadButton.value)
        } else {
          console.error('获取下载按钮设置失败:', response.status)
          const text = await response.text()
          console.error('错误详情:', text)
          // 如果获取失败，保持默认值为 true
          showDownloadButton.value = true
          console.log('获取失败，使用默认值:', showDownloadButton.value)
        }
      } catch (error) {
        console.error('加载下载按钮设置失败:', error)
        // 如果加载失败，保持默认值为 true
        showDownloadButton.value = true
        console.log('加载失败，使用默认值:', showDownloadButton.value)
      }
    }

    // 保存下载按钮显示设置
    const handleDownloadButtonVisibilityChange = async (value) => {
      const oldValue = showDownloadButton.value
      try {
        console.log('正在保存下载按钮设置:', value)
        showDownloadButton.value = value // 立即更新 UI
        
        const response = await fetch('/api/settings/download-button', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Cache-Control': 'no-cache'
          },
          body: JSON.stringify({ visible: value })
        })
        
        if (!response.ok) {
          const text = await response.text()
          console.error('保存设置失败:', response.status, text)
          // 恢复之前的状态
          showDownloadButton.value = oldValue
          console.log('恢复到之前的状态:', oldValue)
          ElMessage.error('保存设置失败')
          return
        }
        
        const data = await response.json()
        console.log('保存设置成功:', data)
        ElMessage.success('设置已保存')
        
        // 重新加载设置以确保同步
        await loadDownloadButtonSetting()
      } catch (error) {
        console.error('保存下载按钮设置失败:', error)
        // 恢复之前的状态
        showDownloadButton.value = oldValue
        console.log('恢复到之前的状态:', oldValue)
        ElMessage.error('保存设置失败')
      }
    }

    onMounted(async () => {
      console.log('=== 组件挂载开始 ===')
      isMobile.value = shouldShowMobileLayout()
      isDesktop.value = shouldShowDesktopLayout()
      deviceType.value = getDeviceType()
      console.log('设备类型检测结果:', {
        isMobile: isMobile.value,
        isDesktop: isDesktop.value,
        deviceType: deviceType.value,
        userAgent: navigator.userAgent
      })
      
      // 加载下载按钮显示设置
      try {
        console.log('开始加载下载按钮设置，当前状态:', showDownloadButton.value)
        await loadDownloadButtonSetting()
        console.log('下载按钮设置加载完成，新状态:', showDownloadButton.value)
      } catch (error) {
        console.error('加载下载按钮设置失败:', error)
      }
      
      // 加载报告列表
      await loadReports()
      console.log('=== 组件挂载完成 ===')
    })
    const uploading = ref(false)
    const editing = ref(false)
    const uploadingAttachment = ref(false)
    const uploadProgress = ref(0)
    const deleting = ref(false)
    const showUploadDialog = ref(false)
    const showEditDialog = ref(false)
    const showAttachmentDialog = ref(false)
    const showQRCodeDialog = ref(false)
    const showDeleteDialog = ref(false)
    const deleteTarget = ref(null)
    const qrCodeData = ref(null)
    const uploadFormRef = ref(null)
    const editFormRef = ref(null)
    const attachmentFormRef = ref(null)
    const attachmentUploadRef = ref(null)
    const qrCodeCanvas = ref(null)

    // 上传表单数据
    const uploadForm = ref({
      sampleName: '',
      reportCodeCustom4: '',
      sampleNumber: '',
      inspectionStatus: '待检验',
      inspectionType: '',
      sampleStatus: '',
      clientUnit: '',
      inspectedUnit: '',
      manufacturerUnit: '',
      completionDeadline: '',
      partnerCompany: '必维',
      // 德凯专用字段
      dekaiReportNumber: '',
      dekaiCompanyName: '',
      dekaiProductName: '',
      dekaiProductModel: '',
      dekaiIssueDate: '',
      // 宝通专用字段
      baotongReportNumber: '',
      baotongApplicant: '',
      baotongApplicantAddress: '',
      baotongManufacturer: '',
      baotongManufacturerAddress: '',
      baotongProductName: '',
      baotongMainModel: '',
      baotongAdditionalModel: ''
    })

    // 编辑表单数据
    const editForm = ref({
      id: '',
      sampleName: '',
      reportCodeCustom4: '',
      sampleNumber: '',
      inspectionStatus: '',
      inspectionType: '',
      sampleStatus: '',
      clientUnit: '',
      inspectedUnit: '',
      manufacturerUnit: '',
      completionDeadline: '',
      partnerCompany: '',
      // 德凯专用字段
      dekaiReportNumber: '',
      dekaiCompanyName: '',
      dekaiProductName: '',
      dekaiProductModel: '',
      dekaiIssueDate: '',
      // 宝通专用字段
      baotongReportNumber: '',
      baotongApplicant: '',
      baotongApplicantAddress: '',
      baotongManufacturer: '',
      baotongManufacturerAddress: '',
      baotongProductName: '',
      baotongMainModel: '',
      baotongAdditionalModel: ''
    })

    // 附件表单数据
    const attachmentForm = ref({
      reportId: '',
      attachmentFile: null
    })

    // 查询表单数据
    const searchForm = ref({
      sampleName: '',
      sampleNumber: '',
      clientUnit: '',
      partnerCompany: '',
      uploadDateRange: []
    })

    // 表单验证规则
    const reportCodeRules = {
      必维: {
        prefix: 'BV',
        custom4: true,
        ruleText: 'BV + 四位数字 + 8位随机大写字母/数字（不含字母 O、I）',
        build: (custom4) => `BV${custom4}${generateRandomAlnum(8)}`
      },
      德凯: {
        prefix: 'DK',
        custom4: true,
        ruleText: 'DK + 四位数字 + 10位随机大写字母/数字（不含字母 O、I）',
        build: (custom4) => `DK${custom4}${generateRandomAlnum(10)}`
      },
      柏纶: {
        prefix: 'BL-',
        custom4: true,
        ruleText: 'BL- + 四位数字 + 8位随机大写字母/数字（不含字母 O、I）',
        build: (custom4) => `BL-${custom4}${generateRandomAlnum(8)}`
      },
      中鼎: {
        prefix: 'CTT',
        custom4: true,
        ruleText: 'CTT + 四位数字 + BU + 6-8位随机数字',
        build: (custom4) => `CTT${custom4}BU${generateRandomDigits(randomInt(6, 8))}`
      },
      宝通: {
        prefix: 'GBT',
        custom4: false,
        ruleText: 'GBT + 10位随机数字',
        build: () => `GBT${generateRandomDigits(10)}`
      },
      中检通: {
        prefix: 'ZJT',
        custom4: false,
        ruleText: 'ZJT + 12位随机字符（2位大写字母、10位数字）+ GR',
        build: () => `ZJT${generateZhongjiantongBody()}GR`
      }
    }

    const sanitizeCustom4 = (value) => {
      return String(value || '').replace(/\D/g, '').slice(0, 4)
    }

    const getCompanyCode = (company) => {
      return reportCodeRules[company]?.prefix || ''
    }

    const generateRandomDigits = (length = 6) => {
      const chars = '0123456789'
      let result = ''
      for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return result
    }

    const generateRandomAlnum = (length) => {
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ0123456789'
      let result = ''
      for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return result
    }

    const generateZhongjiantongBody = () => {
      const letters = 'ABCDEFGHJKLMNPQRSTUVWXYZ'
      const chars = generateRandomDigits(10).split('')
      chars.push(
        letters.charAt(Math.floor(Math.random() * letters.length)),
        letters.charAt(Math.floor(Math.random() * letters.length))
      )

      for (let i = chars.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[chars[i], chars[j]] = [chars[j], chars[i]]
      }
      return chars.join('')
    }

    const randomInt = (min, max) => {
      return Math.floor(Math.random() * (max - min + 1)) + min
    }

    const requiresCustom4 = (company) => {
      return Boolean(reportCodeRules[company]?.custom4)
    }

    const getReportCodeRuleText = (company) => {
      return reportCodeRules[company]?.ruleText || '请选择来源公司'
    }

    const syncSharedReportNumber = (form) => {
      if (form.partnerCompany === '德凯') {
        form.dekaiReportNumber = form.sampleNumber
      } else if (['宝通', '中检通'].includes(form.partnerCompany)) {
        form.baotongReportNumber = form.sampleNumber
      }
    }

    const generateSampleNumberByCompany = (company, custom4) => {
      const rule = reportCodeRules[company]
      if (!rule) return ''

      if (!rule.custom4) {
        return rule.build()
      }

      const normalizedCustom4 = sanitizeCustom4(custom4)
      if (normalizedCustom4.length !== 4) {
        return ''
      }
      return rule.build(normalizedCustom4)
    }

    const extractCustom4FromSampleNumber = (sampleNumber, company) => {
      const value = String(sampleNumber || '')
      const matchers = {
        必维: /^BV(\d{4})[A-HJ-NP-Z0-9]{8}$/,
        德凯: /^DK(\d{4})[A-HJ-NP-Z0-9]{10}$/,
        柏纶: /^BL-(\d{4})[A-HJ-NP-Z0-9]{8}$/,
        中鼎: /^CTT(\d{4})BU\d{6,8}$/
      }
      const match = value.match(matchers[company])
      return match?.[1] || ''
    }

    const isValidReportNumber = (sampleNumber, company) => {
      const value = String(sampleNumber || '')
      const validators = {
        必维: /^BV\d{4}[A-HJ-NP-Z0-9]{8}$/,
        德凯: /^DK\d{4}[A-HJ-NP-Z0-9]{10}$/,
        柏纶: /^BL-\d{4}[A-HJ-NP-Z0-9]{8}$/,
        中鼎: /^CTT\d{4}BU\d{6,8}$/,
        宝通: /^GBT\d{10}$/,
        中检通: /^ZJT(?=\d*[A-HJ-NP-Z]\d*[A-HJ-NP-Z]\d*GR$)[A-HJ-NP-Z0-9]{12}GR$/
      }
      return validators[company]?.test(value) || false
    }

    const updateGeneratedSampleNumber = (form) => {
      const generated = generateSampleNumberByCompany(form.partnerCompany, form.reportCodeCustom4)
      if (generated) {
        form.sampleNumber = generated
        syncSharedReportNumber(form)
      } else {
        form.sampleNumber = ''
        syncSharedReportNumber(form)
      }
    }

    const handleUploadCustom4Input = () => {
      uploadForm.value.reportCodeCustom4 = sanitizeCustom4(uploadForm.value.reportCodeCustom4)
      updateGeneratedSampleNumber(uploadForm.value)
    }

    const handleUploadCompanyChange = () => {
      clearReportNumber(uploadForm.value)
    }

    const generateUploadReportNumber = () => {
      if (requiresCustom4(uploadForm.value.partnerCompany) && uploadForm.value.reportCodeCustom4.length !== 4) {
        uploadForm.value.reportCodeCustom4 = generateRandomDigits(4)
      }
      updateGeneratedSampleNumber(uploadForm.value)
    }

    const clearReportNumber = (form) => {
      form.reportCodeCustom4 = ''
      form.sampleNumber = ''
      syncSharedReportNumber(form)
    }

    const clearUploadReportNumber = () => {
      clearReportNumber(uploadForm.value)
    }

    const handleEditCompanyChange = () => {
      syncSharedReportNumber(editForm.value)
    }

    const uploadRules = {
      sampleName: [
        { required: true, message: '请输入样品名称', trigger: 'blur' }
      ]
    }

    const editRules = {
      sampleName: [
        { required: true, message: '请输入样品名称', trigger: 'blur' }
      ]
    }

    const loadReports = async (reset = false) => {
      loading.value = true
      console.log('🔄 开始加载报告列表, reset:', reset)
      
      try {
        if (reset) {
          currentPage.value = 1
        }

        // 添加时间戳参数防止浏览器缓存
        const timestamp = new Date().getTime()
        const params = new URLSearchParams({
          page: String(currentPage.value),
          pageSize: String(pageSize.value),
          sampleName: searchForm.value.sampleName || '',
          sampleNumber: searchForm.value.sampleNumber || '',
          clientUnit: searchForm.value.clientUnit || '',
          partnerCompany: searchForm.value.partnerCompany || '',
          _t: String(timestamp)
        })
        if (searchForm.value.uploadDateRange?.length === 2) {
          params.set('startDate', searchForm.value.uploadDateRange[0])
          params.set('endDate', searchForm.value.uploadDateRange[1])
        }

        const response = await fetch(`/api/reports?${params.toString()}`, {
          cache: 'no-cache',
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          }
        })
        if (!response.ok) {
          throw new Error('获取报告列表失败')
        }
        
        const data = await response.json()
        console.log('📊 从API获取到的数据:', data)
        console.log('📋 报告数量:', data.data?.length || 0)

        const pageReports = data.data || []
        const pagination = data.pagination || {}
        currentPage.value = pagination.page || currentPage.value
        total.value = pagination.total ?? pageReports.length
        reports.value = pageReports
        filteredReports.value = pageReports

        if (isMobile.value && !reset && currentPage.value > 1) {
          displayReports.value = [...displayReports.value, ...pageReports]
        } else {
          displayReports.value = pageReports
        }
      } catch (err) {
        console.error('加载报告列表失败:', err)
        ElMessage.error('加载报告列表失败')
      } finally {
        loading.value = false
      }
    }

    // PC端分页处理
    const handlePageChange = (page) => {
      currentPage.value = page
      loadReports()
    }

    const handlePageSizeChange = (size) => {
      pageSize.value = size
      loadReports(true)
    }

    // 手机端加载更多
    const loadMore = () => {
      if (!loading.value && displayReports.value.length < total.value) {
        currentPage.value++
        loadReports()
      }
    }

    // 检查是否还有更多数据
    const hasMore = computed(() => {
      return displayReports.value.length < total.value
    })


    

    const getStatusType = (status) => {
      const statusMap = {
        '待检验': 'info',
        '检验中': 'warning',
        '已完成': 'success',
        '已取消': 'danger'
      }
      return statusMap[status] || 'info'
    }

    const formatDeadline = (deadline) => {
      if (!deadline) return ''
      const date = new Date(deadline)
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
    }

    const formatUploadTime = (uploadTime) => {
      if (!uploadTime) return ''
      return new Date(uploadTime).toLocaleString('zh-CN')
    }

    // 查询相关方法
    const toggleSearchForm = () => {
      showSearchForm.value = !showSearchForm.value
    }

    const handleSearch = () => {
      loadReports(true)
    }

    const resetSearch = () => {
      searchForm.value = {
        sampleName: '',
        sampleNumber: '',
        clientUnit: '',
        partnerCompany: '',
        uploadDateRange: []
      }
      loadReports(true)
    }

    // 搜索方法
    const searchReports = () => {
      loadReports(true)
    }

    // 新建报告相关方法
    const cancelUpload = () => {
      showUploadDialog.value = false
      resetUploadForm()
    }

    const resetUploadForm = () => {
      uploadForm.value = {
        sampleName: '',
        reportCodeCustom4: '',
        sampleNumber: '',
        inspectionStatus: '待检验',
        inspectionType: '',
        sampleStatus: '',
        clientUnit: '',
        inspectedUnit: '',
        manufacturerUnit: '',
        completionDeadline: '',
        partnerCompany: '必维',
        // 德凯专用字段
        dekaiReportNumber: '',
        dekaiCompanyName: '',
        dekaiProductName: '',
        dekaiProductModel: '',
        dekaiIssueDate: '',
        // 宝通专用字段
        baotongReportNumber: '',
        baotongApplicant: '',
        baotongApplicantAddress: '',
        baotongManufacturer: '',
        baotongManufacturerAddress: '',
        baotongProductName: '',
        baotongMainModel: '',
        baotongAdditionalModel: ''
      }
      if (uploadFormRef.value) {
        uploadFormRef.value.resetFields()
      }
    }

    const submitUpload = async () => {
      if (!uploadFormRef.value) return
      
      try {
        const valid = await uploadFormRef.value.validate()
        if (!valid) return

        if (!uploadForm.value.sampleNumber || !isValidReportNumber(uploadForm.value.sampleNumber, uploadForm.value.partnerCompany)) {
          ElMessage.warning('请先随机生成符合规则的报告编号')
          return
        }
        
        uploading.value = true
        syncSharedReportNumber(uploadForm.value)
        
        const response = await fetch('/api/reports', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(uploadForm.value)
        })

        if (!response.ok) {
          const errorData = await response.json()
          throw new Error(errorData.error || '创建失败')
        }

        const result = await response.json()
        ElMessage.success('报告创建成功')
        showUploadDialog.value = false
        resetUploadForm()
        loadReports() // 重新加载报告列表
      } catch (err) {
        console.error('创建失败:', err)
        ElMessage.error(err.message || '创建失败')
      } finally {
        uploading.value = false
      }
    }

    

    // 编辑报告相关方法
    const editReport = async (report) => {
      // 先显示对话框
      showEditDialog.value = true
      
      // 等待 DOM 更新后再填充数据
      await nextTick()
      
      editForm.value = {
        id: report.id,
        sampleName: report.sampleName,
        reportCodeCustom4: extractCustom4FromSampleNumber(report.sampleNumber, report.partnerCompany || report.sourceCompany),
        sampleNumber: report.sampleNumber,
        inspectionStatus: report.inspectionStatus,
        inspectionType: report.inspectionType,
        sampleStatus: report.sampleStatus,
        clientUnit: report.clientUnit,
        inspectedUnit: report.inspectedUnit,
        manufacturerUnit: report.manufacturerUnit,
        completionDeadline: report.completionDeadline,
        partnerCompany: report.partnerCompany || report.sourceCompany,
        // 德凯专用字段
        dekaiReportNumber: report.dekaiReportNumber || '',
        dekaiCompanyName: report.dekaiCompanyName || '',
        dekaiProductName: report.dekaiProductName || '',
        dekaiProductModel: report.dekaiProductModel || '',
        dekaiIssueDate: report.dekaiIssueDate || '',
        // 宝通专用字段
        baotongReportNumber: report.baotongReportNumber || '',
        baotongApplicant: report.baotongApplicant || '',
        baotongApplicantAddress: report.baotongApplicantAddress || '',
        baotongManufacturer: report.baotongManufacturer || '',
        baotongManufacturerAddress: report.baotongManufacturerAddress || '',
        baotongProductName: report.baotongProductName || '',
        baotongMainModel: report.baotongMainModel || '',
        baotongAdditionalModel: report.baotongAdditionalModel || ''
      }
    }

    const submitEdit = async () => {
      if (!editFormRef.value) return
      
      try {
        const valid = await editFormRef.value.validate()
        if (!valid) return
        
        editing.value = true
        syncSharedReportNumber(editForm.value)
        
        const response = await fetch(`/api/reports/${editForm.value.id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(editForm.value)
        })

        if (!response.ok) {
          const errorData = await response.json()
          throw new Error(errorData.error || '更新失败')
        }

        ElMessage.success('报告更新成功')
        showEditDialog.value = false
        loadReports()
      } catch (err) {
        console.error('更新失败:', err)
        ElMessage.error(err.message || '更新失败')
      } finally {
        editing.value = false
      }
    }

    const cancelEdit = () => {
      showEditDialog.value = false
    }

    // 上传附件相关方法
    const uploadAttachment = (report) => {
      console.log('开始上传附件，报告信息:', {
        reportId: report.id,
        sampleName: report.sampleName,
        existingAttachment: report.attachment
      })
      
      attachmentForm.value.reportId = report.id
      attachmentForm.value.attachmentFile = null
      uploadProgress.value = 0
      showAttachmentDialog.value = true
      
      // 清空上传组件的文件列表
      if (attachmentUploadRef.value) {
        attachmentUploadRef.value.clearFiles()
      }
    }

    const handleAttachmentChange = (file) => {
      attachmentForm.value.attachmentFile = file.raw
    }

    const handleAttachmentRemove = () => {
      attachmentForm.value.attachmentFile = null
      uploadProgress.value = 0
    }

    const submitAttachment = async () => {
      if (!attachmentForm.value.attachmentFile) {
        ElMessage.error('请选择要上传的文件')
        return
      }
      
      console.log('提交附件上传，参数:', {
        reportId: attachmentForm.value.reportId,
        fileName: attachmentForm.value.attachmentFile.name,
        fileSize: attachmentForm.value.attachmentFile.size
      })
      
      uploadingAttachment.value = true
      uploadProgress.value = 0
      
      try {
        const formData = new FormData()
        formData.append('file', attachmentForm.value.attachmentFile)
        formData.append('reportId', attachmentForm.value.reportId)
        
        // 使用 XMLHttpRequest 来支持上传进度
        const xhr = new XMLHttpRequest()
        
        // 监听上传进度
        xhr.upload.addEventListener('progress', (event) => {
          if (event.lengthComputable) {
            uploadProgress.value = Math.round((event.loaded / event.total) * 100)
          }
        })
        
        // 创建 Promise 来处理 XMLHttpRequest
        const uploadPromise = new Promise((resolve, reject) => {
          xhr.onload = () => {
            if (xhr.status === 200) {
              try {
                const response = JSON.parse(xhr.responseText)
                resolve(response)
              } catch (e) {
                reject(new Error('响应解析失败'))
              }
            } else {
              try {
                const errorData = JSON.parse(xhr.responseText)
                reject(new Error(errorData.error || '上传失败'))
              } catch (e) {
                reject(new Error(`上传失败 (${xhr.status})`))
              }
            }
          }
          
          xhr.onerror = () => {
            reject(new Error('网络错误'))
          }
          
          xhr.open('POST', '/api/upload-attachment')
          xhr.send(formData)
        })
        
        const result = await uploadPromise
        
        console.log('附件上传成功，服务器响应:', result)
        ElMessage.success('附件上传成功')
        showAttachmentDialog.value = false
        resetAttachmentForm()
        loadReports()
      } catch (err) {
        console.error('附件上传失败:', err)
        ElMessage.error(err.message || '上传失败')
      } finally {
        uploadingAttachment.value = false
        uploadProgress.value = 0
      }
    }

    const cancelAttachment = () => {
      showAttachmentDialog.value = false
      resetAttachmentForm()
    }
    
    const resetAttachmentForm = () => {
      attachmentForm.value.reportId = ''
      attachmentForm.value.attachmentFile = null
      uploadProgress.value = 0
      
      // 清空上传组件的文件列表
      if (attachmentUploadRef.value) {
        attachmentUploadRef.value.clearFiles()
      }
    }

    // 生成二维码相关方法
    const generateQRCode = async (report) => {
      qrCodeData.value = null
      showQRCodeDialog.value = true
      
      try {
        // 生成二维码数据（报告详情链接）
        const company = report.partnerCompany || report.sourceCompany
        const qrContent = company === '中检通'
          ? `${window.location.origin}/zhongjiantong/?q=${encodeURIComponent(report.id)}`
          : `${window.location.origin}/view/${report.id}`
        
        // 动态导入 qrcode 库
        const QRCode = await import('qrcode')
        
        // 等待DOM更新
        await nextTick()
        
        // 再次等待确保canvas元素完全准备就绪
        setTimeout(async () => {
          try {
            if (qrCodeCanvas.value) {
              await QRCode.toCanvas(qrCodeCanvas.value, qrContent, {
                width: 200,
                margin: 2,
                color: {
                  dark: '#000000',
                  light: '#FFFFFF'
                }
              })
              qrCodeData.value = qrContent
              console.log('二维码生成成功:', qrContent)
            } else {
              console.error('Canvas元素未找到')
              ElMessage.error('二维码生成失败：Canvas元素未找到')
            }
          } catch (err) {
            console.error('二维码生成失败:', err)
            ElMessage.error('二维码生成失败: ' + err.message)
            qrCodeData.value = 'error' // 设置错误状态
          }
        }, 100)
      } catch (error) {
        console.error('二维码生成失败:', error)
        ElMessage.error('二维码生成失败: ' + error.message)
        qrCodeData.value = 'error' // 设置错误状态
      }
    }

    const saveQRCode = () => {
      if (!qrCodeCanvas.value) return
      
      try {
        const canvas = qrCodeCanvas.value
        const link = document.createElement('a')
        link.download = `qrcode_${Date.now()}.png`
        link.href = canvas.toDataURL()
        link.click()
        ElMessage.success('二维码保存成功')
      } catch (error) {
        console.error('保存二维码失败:', error)
        ElMessage.error('保存失败')
      }
    }

    // 删除报告相关方法
    const deleteReport = (report) => {
      deleteTarget.value = report
      showDeleteDialog.value = true
    }

    const confirmDeleteReport = async () => {
      if (!deleteTarget.value) return
      
      try {
        deleting.value = true
        
        const response = await fetch(`/api/reports/${deleteTarget.value.id}`, {
          method: 'DELETE'
        })

        if (!response.ok) {
          const errorData = await response.json()
          throw new Error(errorData.error || '删除失败')
        }

        ElMessage.success('报告删除成功')
        showDeleteDialog.value = false
        deleteTarget.value = null
        loadReports() // 重新加载报告列表
      } catch (err) {
        console.error('删除失败:', err)
        ElMessage.error(err.message || '删除失败')
      } finally {
        deleting.value = false
      }
    }

    

    // 导出数据方法
    const exportData = () => {
      if (filteredReports.value.length === 0) {
        ElMessage.warning('没有数据可以导出')
        return
      }

      // 准备导出数据
      const exportData = filteredReports.value.map(report => {
        // 直接使用COS文件URL
        const reportUrl = report.attachment?.filePath || report.filePath || ''

        return {
          '样品名称': report.sampleName || '',
          '报告编号': report.sampleNumber || '',
          '检验状态': report.inspectionStatus || '',
          '检验类型': report.inspectionType || '',
          '样品状态': report.sampleStatus || '',
          '委托单位': report.clientUnit || '',
          '受检单位': report.inspectedUnit || '',
          '生产单位': report.manufacturerUnit || '',
          '完成期限': report.completionDeadline || '',
          '来源公司': report.partnerCompany || '',
          '报告URL': reportUrl,
          '上传时间': formatUploadTime(report.uploadTime)
        }
      })

      // 转换为CSV格式
      const headers = Object.keys(exportData[0])
      const csvContent = [
        headers.join(','),
        ...exportData.map(row => 
          headers.map(header => {
            const value = row[header] || ''
            // 如果值包含逗号、换行符或双引号，需要用双引号包围并转义
            if (value.includes(',') || value.includes('\n') || value.includes('"')) {
              return `"${value.replace(/"/g, '""')}"`
            }
            return value
          }).join(',')
        )
      ].join('\n')

      // 创建并下载文件
      const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', `报告数据_${new Date().toISOString().slice(0, 10)}.csv`)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)

      ElMessage.success(`成功导出 ${exportData.length} 条数据`)
    }

    // 刷新报告列表
    const refreshReports = async () => {
      console.log('🔄 手动刷新报告列表')
      await loadReports(true)
      ElMessage.success('报告列表已刷新')
    }

    return {
      reports,
      filteredReports,
      loading,
      showSearchForm,
      searchForm,
      isMobile,
      isDesktop,
      deviceType,
      showDownloadButton,
      uploading,
      editing,
      uploadingAttachment,
      uploadProgress,
      deleting,
      showUploadDialog,
      showEditDialog,
      showAttachmentDialog,
      showQRCodeDialog,
      showDeleteDialog,
      deleteTarget,
      qrCodeData,
      uploadForm,
      editForm,
      attachmentForm,
      uploadRules,
      editRules,
      uploadFormRef,
      editFormRef,
      attachmentFormRef,
      attachmentUploadRef,
      qrCodeCanvas,
      loadReports,
      refreshReports,
      getStatusType,
      formatDeadline,
      formatUploadTime,
      toggleSearchForm,
      handleSearch,
      resetSearch,
      searchReports,
      currentPage,
      pageSize,
      total,
      displayReports,
      handlePageChange,
      handlePageSizeChange,
      loadMore,
      hasMore,
      cancelUpload,
      getCompanyCode,
      getReportCodeRuleText,
      requiresCustom4,
      handleUploadCustom4Input,
      handleUploadCompanyChange,
      generateUploadReportNumber,
      clearUploadReportNumber,
      submitUpload,
      editReport,
      handleEditCompanyChange,
      submitEdit,
      cancelEdit,
      uploadAttachment,
      handleAttachmentChange,
      handleAttachmentRemove,
      submitAttachment,
      cancelAttachment,
      generateQRCode,
      saveQRCode,
      deleteReport,
      confirmDeleteReport,
      exportData,
      handleDownloadButtonVisibilityChange,
      Loading
    }
  }
}
</script>

<style scoped>
.report-list-container {
  min-height: calc(100vh - 64px);
  padding: 28px;
  background:
    linear-gradient(180deg, #f8fafc 0%, #f3f6fb 42%, #eef3f7 100%);
  color: #172033;
}

.code-preview-tip {
  margin-top: 8px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.45;
}

.report-code-builder {
  --report-theme: #2f7dd1;
  --report-theme-soft: #eef6ff;
  --report-theme-border: #c7d9ee;
  --report-theme-shadow: rgba(47, 125, 209, 0.18);
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
}

.report-code-prefix {
  flex: 0 0 auto;
  min-width: 70px;
  height: 40px;
  padding: 0 16px;
  border: 1px solid var(--report-theme-border);
  border-radius: 8px;
  background: var(--report-theme-soft);
  color: var(--report-theme);
  font-size: 17px;
  font-weight: 800;
  line-height: 38px;
  text-align: center;
}

.report-code-custom-input {
  flex: 0 0 190px;
}

.report-code-auto-tip {
  display: inline-flex;
  align-items: center;
  flex: 0 0 190px;
  height: 40px;
  padding: 0 14px;
  border: 1px solid var(--report-theme-border);
  border-radius: 8px;
  background: var(--report-theme-soft);
  color: var(--report-theme);
  font-size: 14px;
  font-weight: 700;
}

.report-code-action {
  flex: 0 0 118px;
  height: 40px;
  border-color: var(--report-theme) !important;
  background: var(--report-theme) !important;
  box-shadow: 0 8px 18px var(--report-theme-shadow) !important;
}

.report-code-action:hover {
  border-color: var(--report-theme) !important;
  background: var(--report-theme) !important;
  filter: brightness(0.94);
}

.report-code-clear {
  flex: 0 0 90px;
  height: 40px;
}

.report-code-result {
  --report-theme: #2f7dd1;
  --report-theme-soft: #eef6ff;
  --report-theme-border: #c7d9ee;
  display: block;
  margin-top: 12px;
  width: 100%;
}

.edit-report-code-result {
  margin-top: 0;
}

.report-code-result :deep(.el-input__wrapper) {
  background: linear-gradient(90deg, var(--report-theme-soft), #ffffff);
  box-shadow: 0 0 0 1px var(--report-theme-border) inset;
}

.report-code-result :deep(.el-input__inner) {
  color: var(--report-theme);
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0;
}

:deep(.el-card) {
  border: 1px solid #e5eaf2;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.07);
}

:deep(.el-card__header) {
  padding: 16px 20px;
  border-bottom: 1px solid #edf1f6;
}

:deep(.el-card__body) {
  padding: 20px;
}

.search-card {
  margin-bottom: 18px;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  color: #172033;
  font-size: 16px;
  font-weight: 700;
}

.header-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.search-form {
  padding: 2px 0 0;
}

.search-form .el-form {
  display: flex;
  flex-wrap: wrap;
  gap: 14px 18px;
}

.search-form .el-form-item {
  margin: 0;
}

.responsive-form {
  width: 100%;
}

:deep(.el-form-item) {
  margin-bottom: 18px;
}

:deep(.el-form-item__label) {
  color: #475569;
  font-weight: 600;
}

:deep(.el-input__wrapper),
:deep(.el-select .el-input__wrapper),
:deep(.el-textarea__inner) {
  min-height: 36px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 0 0 1px #d9e1ec inset;
  transition: box-shadow 0.2s, background-color 0.2s;
}

:deep(.el-input__wrapper:hover),
:deep(.el-select .el-input__wrapper:hover),
:deep(.el-textarea__inner:hover) {
  box-shadow: 0 0 0 1px #b8c4d6 inset;
}

:deep(.el-input__wrapper.is-focus),
:deep(.el-select .el-input__wrapper.is-focus),
:deep(.el-textarea__inner:focus) {
  box-shadow: 0 0 0 1px #2f7dd1 inset, 0 0 0 3px rgba(47, 125, 209, 0.12);
}

:deep(.el-input-group__prepend),
:deep(.el-input-group__append) {
  border: 0;
  color: #334155;
  background: #eef4fa;
  box-shadow: 0 0 0 1px #d9e1ec inset;
}

:deep(.el-select) {
  width: 100%;
}

:deep(.el-button) {
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: 0;
}

:deep(.el-button--primary) {
  border-color: #2f7dd1;
  background: #2f7dd1;
  box-shadow: 0 8px 18px rgba(47, 125, 209, 0.2);
}

:deep(.el-button--primary:hover) {
  border-color: #256fbf;
  background: #256fbf;
}

:deep(.el-button--success) {
  border-color: #159a7c;
  background: #159a7c;
  box-shadow: 0 8px 18px rgba(21, 154, 124, 0.18);
}

:deep(.el-button--warning) {
  border-color: #d78b17;
  background: #d78b17;
  box-shadow: 0 8px 18px rgba(215, 139, 23, 0.16);
}

:deep(.el-button--danger) {
  border-color: #d94a4a;
  background: #d94a4a;
  box-shadow: 0 8px 18px rgba(217, 74, 74, 0.16);
}

:deep(.el-button--text) {
  color: #2f7dd1;
  box-shadow: none;
}

:deep(.el-switch__label) {
  color: #64748b;
  font-size: 13px;
}

:deep(.el-table) {
  overflow: hidden;
  border-radius: 8px;
  color: #263246;
  font-size: 13px;
}

:deep(.el-table__inner-wrapper::before) {
  display: none;
}

:deep(.el-table th.el-table__cell) {
  padding: 11px 0;
  border-bottom: 1px solid #dce4ef;
  background: #f3f6fa;
  color: #475569;
  font-weight: 700;
}

:deep(.el-table td.el-table__cell) {
  padding: 12px 0;
  border-bottom: 1px solid #edf1f6;
}

:deep(.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell) {
  background: #fafcff;
}

:deep(.el-table__body tr:hover > td.el-table__cell) {
  background: #eef6ff;
}

:deep(.el-table .el-button--small) {
  min-width: 58px;
  padding: 6px 10px;
  font-size: 12px;
}

:deep(.el-tag) {
  min-width: 58px;
  justify-content: center;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}

:deep(.el-pagination) {
  padding: 12px 0 0;
}

:deep(.el-pagination button),
:deep(.el-pager li) {
  border-radius: 8px;
}

.empty-state {
  padding: 52px 20px;
  text-align: center;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

:deep(.el-dialog) {
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);
}

:deep(.el-dialog__header) {
  position: relative;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 18px 22px;
  min-height: 58px;
  border-bottom: 1px solid #edf1f6;
  background: #f8fafc;
}

:deep(.el-dialog__title) {
  display: block;
  color: #172033;
  font-size: 17px;
  font-weight: 700;
  line-height: 22px;
}

:deep(.el-dialog__headerbtn) {
  top: 0;
  right: 14px;
  width: 42px;
  height: 58px;
}

:deep(.el-dialog__close) {
  color: #64748b;
  font-size: 18px;
}

:deep(.el-dialog__headerbtn:hover .el-dialog__close) {
  color: #172033;
}

:deep(.el-dialog__body) {
  padding: 20px 22px 10px;
}

:deep(.el-dialog__footer) {
  padding: 14px 22px 20px;
  border-top: 1px solid #edf1f6;
  background: #fbfcfe;
}

:deep(.el-divider__text) {
  color: #334155;
  font-weight: 700;
}

:deep(.el-upload),
:deep(.el-upload-dragger) {
  width: 100%;
}

.el-upload__tip {
  margin-top: 8px;
  color: #64748b;
  font-size: 12px;
}

.qr-code-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 22px;
}

.qr-code-display {
  text-align: center;
}

.qr-code-display canvas {
  border: 1px solid #e5eaf2;
  border-radius: 8px;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
}

.qr-code-info {
  margin-top: 14px;
  color: #475569;
  font-size: 14px;
}

.qr-code-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  color: #475569;
}

.qr-code-loading .el-icon {
  margin-bottom: 10px;
  color: #2f7dd1;
  font-size: 26px;
}

.qr-code-loading p {
  margin: 0;
  font-size: 14px;
}

.preview-content {
  padding: 20px;
}

.report-info,
.attachment-item {
  padding: 18px;
  border: 1px solid #e5eaf2;
  border-radius: 8px;
  background: #f8fafc;
}

.report-info {
  margin-bottom: 20px;
}

.report-info h3 {
  margin: 0 0 14px;
  color: #172033;
  font-size: 19px;
  font-weight: 700;
}

.report-info p,
.attachment-info p {
  margin: 6px 0;
  color: #475569;
  font-size: 14px;
  line-height: 1.6;
}

.report-info strong {
  margin-right: 8px;
  color: #172033;
  font-weight: 700;
}

.report-file,
.report-attachments {
  margin-top: 20px;
  padding-top: 18px;
  border-top: 1px solid #e5eaf2;
}

.report-file h4,
.report-attachments h4 {
  margin: 0 0 14px;
  color: #172033;
  font-size: 16px;
  font-weight: 700;
}

.file-actions {
  display: flex;
  gap: 10px;
}

.file-actions .el-button {
  flex: 1;
}

.attachment-item {
  margin-bottom: 14px;
}

.attachment-item:last-child {
  margin-bottom: 0;
}

.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.report-card {
  margin: 0;
  padding: 16px;
  border: 1px solid #e5eaf2;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08);
  transition: box-shadow 0.2s, transform 0.2s;
}

.report-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.1);
}

.card-header-mobile {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #edf1f6;
}

.report-title h3 {
  margin: 0 0 6px;
  color: #172033;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.4;
}

.sample-number {
  display: inline-flex;
  max-width: 100%;
  padding: 3px 8px;
  border-radius: 999px;
  background: #eef4fa;
  color: #475569;
  font-size: 12px;
  line-height: 18px;
  word-break: break-all;
}

.card-content {
  margin-bottom: 14px;
}

.info-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 0;
  border-bottom: 1px solid #f0f3f7;
}

.info-row:last-child {
  border-bottom: none;
}

.info-row .label {
  flex: 0 0 auto;
  min-width: 70px;
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
}

.info-row .value {
  flex: 1;
  color: #263246;
  font-size: 13px;
  line-height: 1.45;
  text-align: right;
  word-break: break-word;
}

.card-actions {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.card-actions .el-button {
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 7px 8px;
  font-size: 12px;
}

.form-actions {
  margin-left: auto;
}

.load-more-container {
  margin-top: 18px;
  padding: 18px 0;
  text-align: center;
}

.load-more-container .el-button {
  width: 190px;
  height: 38px;
}

.upload-status {
  margin-top: 8px;
  color: #475569;
  font-size: 14px;
  text-align: center;
}

:deep(.el-progress) {
  margin-bottom: 8px;
}

:deep(.el-progress__text) {
  font-weight: 700;
}

@media (max-width: 768px) {
  .report-list-container {
    min-height: calc(100vh - 56px);
    padding: 14px;
  }

  :deep(.el-card__header) {
    padding: 14px 16px;
  }

  :deep(.el-card__body) {
    padding: 16px;
  }

  .card-header {
    align-items: stretch;
    flex-direction: column;
  }

  .search-card .card-header {
    align-items: center;
    flex-direction: row;
  }

  .header-actions {
    justify-content: space-between;
  }

  .responsive-form .el-form-item {
    display: block;
    width: 100%;
    margin-right: 0 !important;
    margin-bottom: 14px;
  }

  .responsive-form .el-form-item__label {
    display: block;
    width: 100% !important;
    margin-bottom: 6px;
    text-align: left !important;
  }

  .responsive-form .el-form-item__content {
    width: 100%;
    margin-left: 0 !important;
  }

  .form-actions {
    margin-left: 0;
    text-align: left;
  }

  .form-actions .el-button {
    margin: 4px 6px 4px 0;
  }

  .report-code-builder {
    align-items: stretch;
    flex-wrap: wrap;
    gap: 10px;
  }

  .report-code-prefix,
  .report-code-custom-input,
  .report-code-auto-tip {
    flex: 1 1 130px;
  }

  .report-code-action,
  .report-code-clear {
    flex: 1 1 120px;
  }

  :deep(.el-dialog) {
    width: calc(100% - 24px) !important;
    margin: 12px auto;
  }

  :deep(.el-dialog__body) {
    padding: 16px;
  }

  :deep(.el-form-item__label) {
    width: 96px !important;
  }

  .mobile-card-list {
    gap: 12px;
  }
}

@media (max-width: 480px) {
  .report-list-container {
    padding: 10px;
  }

  :deep(.el-card__body) {
    padding: 12px;
  }

  .header-actions {
    gap: 8px;
  }

  .header-actions :deep(.el-switch) {
    width: 100%;
    margin-left: 0 !important;
  }

  :deep(.el-form-item__label) {
    width: 82px !important;
    font-size: 13px;
  }

  .report-card {
    padding: 14px;
  }

  .report-code-builder {
    display: grid;
    grid-template-columns: 86px 1fr;
  }

  .report-code-prefix,
  .report-code-custom-input,
  .report-code-auto-tip,
  .report-code-action,
  .report-code-clear {
    width: 100%;
    min-width: 0;
  }

  .report-code-auto-tip,
  .report-code-action,
  .report-code-clear {
    grid-column: span 2;
  }

  .report-title h3 {
    font-size: 14px;
  }

  .info-row .label,
  .info-row .value {
    font-size: 12px;
  }

  .card-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .load-more-container .el-button {
    width: 150px;
    height: 36px;
  }

  .upload-status {
    font-size: 12px;
  }
}
</style>
